import React from 'react';
import cx from 'classnames';
import ReactiveListeningStatus from '../Global/ReactiveListeningStatus/ReactiveListeningStatus';
import IconOverlays from './IconOverlays';
import Timer from './Timer';
import useFakeVolumeLevel from './useFakeVolumeLevel';

const DialogStudentTurn = ({
  showStudentTurn,
  showTimer,
  showMicrophone,
  showPauseOverlay,
  showCheckmarkOverlay,
  fakeActiveListeningStatus,
  transcript,
  submitTimerElapsed,
  getNoSubmitTimeout,
}) => {
  const volumeLevel = useFakeVolumeLevel(transcript);

  return (
    <div
      className={cx('dialogDisplay__studentTurn', {
        'dialogDisplay__studentTurn--shown': showStudentTurn,
        'dialogDisplay--invisible': !showStudentTurn,
      })}
    >
      <div className={cx('dialogDisplay__timer', { 'dialogDisplay--invisible': !showTimer })}>
        <Timer submitTimerElapsed={submitTimerElapsed} getNoSubmitTimeout={getNoSubmitTimeout} />
      </div>
      <div className={cx('dialogDisplay__micBox', { 'dialogDisplay--invisible': !showMicrophone })}>
        <div className="dialogDisplay__mic">
          <ReactiveListeningStatus forceActiveState={fakeActiveListeningStatus} volumeLevel={volumeLevel} />
          <IconOverlays showPauseOverlay={showPauseOverlay} showCheckmarkOverlay={showCheckmarkOverlay} />
        </div>
      </div>
    </div>
  );
};

export default DialogStudentTurn;
